/**
 * 言語切り替えボタン修正
 * WeglotのボタンクリックでURLを変更してページをリロード
 */

(function() {
  'use strict';

  let attempts = 0;
  const MAX_ATTEMPTS = 5;
  let initialized = false;

  function initLanguageSwitcher() {
    if (initialized) return;

    // Weglot言語スイッチャーを検索
    const enButton = document.getElementById('weglot-language-en');
    const jaButton = document.getElementById('weglot-language-ja');

    if (enButton) {
      enButton.addEventListener('click', function(e) {
        e.preventDefault();

        // 現在のパス取得
        const currentPath = window.location.pathname;

        // 既に/enの場合は何もしない
        if (currentPath.startsWith('/en')) {
          console.log('[Language Switcher] Already in English');
          return;
        }

        // /en に変更してリダイレクト
        const newPath = '/en' + currentPath;
        console.log('[Language Switcher] Switching to EN:', newPath);
        window.location.href = newPath + window.location.search;
      });
    }

    if (jaButton) {
      jaButton.addEventListener('click', function(e) {
        e.preventDefault();

        // 現在のパス取得
        const currentPath = window.location.pathname;

        // 既に日本語（/enなし）の場合は何もしない
        if (!currentPath.startsWith('/en')) {
          console.log('[Language Switcher] Already in Japanese');
          return;
        }

        // /en を削除してリダイレクト
        const newPath = currentPath.replace(/^\/en/, '') || '/';
        console.log('[Language Switcher] Switching to JA:', newPath);
        window.location.href = newPath + window.location.search;
      });
    }

    if (enButton || jaButton) {
      initialized = true;
      console.log('[Language Switcher] Initialized');
      return;
    }

    attempts += 1;
    if (attempts >= MAX_ATTEMPTS) {
      // Weglotボタンがないページでは正常にスキップ
      return;
    }

    setTimeout(initLanguageSwitcher, 800);
  }

  // DOM読み込み完了後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanguageSwitcher);
  } else {
    initLanguageSwitcher();
  }
})();
